import { render, staticRenderFns } from "./r-avatar-status.vue?vue&type=template&id=b1453a20"
import script from "./r-avatar-status.vue?vue&type=script&lang=js"
export * from "./r-avatar-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1453a20')) {
      api.createRecord('b1453a20', component.options)
    } else {
      api.reload('b1453a20', component.options)
    }
    module.hot.accept("./r-avatar-status.vue?vue&type=template&id=b1453a20", function () {
      api.rerender('b1453a20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/avatar/r-avatar-status.vue"
export default component.exports